import { render, staticRenderFns } from "./CostModal.vue?vue&type=template&id=12f01b94&"
import script from "./CostModal.vue?vue&type=script&lang=js&"
export * from "./CostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports